export default __webpack_public_path__ + "static/media/wi-snow-wind.490d0845.svg";